import { Theme } from "@mui/material";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import withStyles from "@mui/styles/withStyles";
import React from "react";

const CustomCheckbox = withStyles((theme: Theme) => ({
  root: {
    "&.Mui-checked": {
      color: theme.palette.tertiary.mainDark,
    },
    "&.Mui-disabled": {
      boxShadow: "none",
      color: theme.palette.quaternary.grey,
    },
  },
}))(Checkbox);

export type Props = Omit<CheckboxProps, "color">;

const CustomFormCheckBox: React.FC<Props> = (args) => {
  return <CustomCheckbox data-cy="checkbox-input" color="primary" {...args} />;
};

export default CustomFormCheckBox;
